export const OrderStatusCssClasses = ["info", "success", "danger", "warning"];
export const OrderStatusTitles = ["On The Way", "Delivered", "Rejected", "Cancelled"];
export const PaymentStatusCssClasses = ["info", "success", "danger", "warning","danger"];
export const PaymentStatusTitles = ["COD", "Received", "Cancelled", "Refund Initiated","Declined"];


export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    lastName: "",
    firstName: "",
    email: "",
    ipAddress: ""
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNo: 1,
  pageSize: 10
};
